/****************************************************
 * Module Name:  virtualTeamMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { DataGridPro, GridToolbarExport, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import { Avatar, Box, Button, Chip, Tooltip, Menu, MenuItem } from "@mui/material";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import AddVirtualTeamModal from "./addVirtualTeamModal";
import Utility from "../../utility/utility";
import VirtualTeamProxy from "../../utility/proxy/manager/permissionProxy/virtualTeamProxy";
import AddUserModal from "../master/addUserModal";
import UserProxy from "../../utility/proxy/manager/userProxy";
import Constants from "../../utility/constants";
import CommonSnackbar from "../common/commonSnackBar";
import NoPermission from "../common/noPermission";
import PageTitle from "../common/pageTitle";

export class VirtualTeamMaster extends Component {
  constructor(props) {
    super(props);

    this.state = {
      virtualTeam: [],
      showAddVirtualTeamModal: false,
      showAddUserModal: false,
      userId: "",
      loadingButton: false,
      editOperation: false,
      sourceData: {},
      errorSnackbar: false,
      accesDenied: false,
      showVirtualTeamLoadSpinner: true,
      anchorEl: null,
      openMenuId: null,
      openUsersMenuId: null,
      anchorEl1: null,
      openMenuId1: null,
      openOwnerMenuId: null,
      columnNames: [],
      local_Permission: Constants.USER_PERMISSION.filter(
        (iPermission) =>
          iPermission.permissionid ===
          Constants.PERMISSIONS.PERMISSION_VIRTUALTEAM
      ),
    };

    this.checkPermission()
  }

  componentDidMount() {
    PageTitle("PERMISSION_VIRTUALTEAM");
  }

  checkPermission = () => {
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      this.setState({
        accesDenied: true
      })
    } else {
      this.fetchVirtualTeamData(false);
    }
  }

  fetchVirtualTeamData = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showVirtualTeamLoadSpinner: true });
    VirtualTeamProxy.GetAllVirtualTeamDetail((responseData) => {
      if (responseData) {
        this.setState({
          virtualTeam: responseData,
          showVirtualTeamLoadSpinner: false,
        })
        const filterMap = this.generateFilterMap(Array.isArray(responseData) ? responseData : [responseData]);
        this.prepareColumns(filterMap);
      } else {
        this.setState({
          errorSnackbar: true,
          showVirtualTeamLoadSpinner: false,
        })
      }
    }
    );
  };


  prepareColumns = (filterMap) => {
    let columnNames = [];
    const columnData = this.initialColumns();

    columnData.forEach(iCol => {
      if (iCol.field === "virtualteamusers") {
        iCol.type = "singleSelect";
        iCol.valueOptions = filterMap ? filterMap.virtualteamusers : [];
        iCol.filterOperators = Utility.customFilters(filterMap, iCol.field, 'userid', 'username');
      }
      if (iCol.field === "virtualteamowners") {
        iCol.type = "singleSelect";
        iCol.valueOptions = filterMap ? filterMap.virtualteamowners : [];
        iCol.filterOperators = Utility.customFilters(filterMap, iCol.field, 'userid', 'username');
      }
      columnNames.push(iCol);
    });
    this.setState({
      columnNames: columnNames
    })
  }

  generateFilterMap = (responseData) => {
    const filterMap = {};

    // Process team users
    const teamUsers = responseData.flatMap((team) =>
      team.virtualteamusers.map((user) => ({
        id: user.userid,
        username: user.username,
      }))
    );
    filterMap.virtualteamusers = [
      ...new Set(
        teamUsers.map((user) => `${user.id} | ${user.username}`)
      ),
    ];

    // Process team owners
    const teamOwners = responseData.flatMap((team) =>
      team.virtualteamowners.map((owner) => ({
        id: owner.userid,
        username: owner.username,
      }))
    );

    filterMap.virtualteamowners = [
      ...new Set(
        teamOwners.map(
          (owner) => `${owner.id} | ${owner.username}`
        )
      ),
    ];

    return filterMap;
  };

  handleUserMenuClick = (event, id) => {
    this.setState({
      anchorEl: event.currentTarget,
      openUsersMenuId: id,
    });
  };

  handleUserMenuClose = () => {
    this.setState({
      anchorEl: null,
      openUsersMenuId: null,
    });
  };

  handleOwnerMenuClick = (event, id) => {
    this.setState({
      anchorEl1: event.currentTarget,
      openOwnerMenuId: id,
    });
  };

  handleOwnerMenuClose = () => {
    this.setState({
      anchorEl1: null,
      openOwnerMenuId: null,
    });
  };


  initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      align: "center",
      renderCell: renderCellExpand,
    },
    {
      field: "name",
      headerName: "NAME",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "description",
      headerName: "DESCRIP",
      headerAlign: "center",
      align: "center",
      flex: 1,
      renderCell: renderCellExpand,
    },
    {
      field: "created",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      flex: 1,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "virtualteamusers",
      headerName: "USERS",
      headerAlign: "center",
      align: "center",
      width: 400,
      renderCell: (params) => params.value.length === 0 ? null : (
        <Box>
          <Button
            aria-controls={this.state.openUsersMenuId === params.id ? 'role-users-menu' : undefined}
            aria-haspopup="true"
            onClick={(event) => this.handleUserMenuClick(event, params.id)}
          >
            View Users
          </Button>
          <Menu
            id="role-users-menu"
            anchorEl={this.state.anchorEl}
            open={this.state.openUsersMenuId === params.id}
            onClose={this.handleUserMenuClose}
            sx={{
              height: "40rem"
            }}
          >
            {params.value.map((item, index) => (
              <MenuItem>
                <Chip
                  key={index}
                  clickable
                  avatar={<Avatar sx={{ width: 'auto', fontSize: 10 }}>{item.userid}</Avatar>}
                  label={item.username}
                  onClick={() => {
                    this.setState({
                      showAddUserModal: true,
                      editOperation: false,
                      sourceData: undefined,
                      userId: item.userid,
                      anchorEl: null,
                      openUsersMenuId: null,
                    });
                  }}
                  disabled={
                    Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CUSTOMER &&
                        iPermission.type === "UPDATE"
                    ) === undefined
                  }
                  sx={{ margin: "0px 10px 10px 0px", fontSize: 10 }}
                />
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ),
      disableExport: true,
      sortComparator: (v1, v2) => Utility.sortOperatorFn(v1, v2, "username")
    },
    {
      field: "virtualteamowners",
      headerName: "Owners",
      headerAlign: "center",
      align: "center",
      width: 400,
      renderCell: (params) => params.value.length === 0 ? null : (
        <Box>
          <Button
            aria-controls={this.state.openOwnerMenuId === params.id ? 'role-owners-menu' : undefined}
            aria-haspopup="true"
            onClick={(event) => this.handleOwnerMenuClick(event, params.id)}
          >
            View Owners
          </Button>
          <Menu
            id="role-owners-menu"
            anchorEl={this.state.anchorEl1}
            open={this.state.openOwnerMenuId === params.id}
            onClose={this.handleOwnerMenuClose}
            sx={{
              height: "40rem"
            }}
          >
            {params.value.map((item, index) => (
              <MenuItem>
                <Chip
                  key={index}
                  clickable
                  avatar={<Avatar sx={{ width: 'auto', fontSize: 10 }}>{item.userid}</Avatar>}
                  label={item.username}
                  onClick={() => {
                    this.setState({
                      showAddUserModal: true,
                      editOperation: false,
                      sourceData: undefined,
                      userId: item.userid,
                      anchorEl1: null,
                      openOwnerMenuId: null,
                    });
                  }}
                  disabled={
                    Constants.USER_PERMISSION.find(
                      (iPermission) =>
                        iPermission.permissionid ===
                        Constants.PERMISSIONS.MASTER_CUSTOMER &&
                        iPermission.type === "UPDATE"
                    ) === undefined
                  }
                  sx={{ margin: "0px 10px 10px 0px", fontSize: 10 }}
                />
              </MenuItem>
            ))}
          </Menu>
        </Box>
      ),
      disableExport: true,
      sortComparator: (v1, v2) => Utility.sortOperatorFn(v1, v2, "username")
    },
    {
      field: "edit",
      headerName: "EDIT",
      headerAlign: "center",
      align: "center",
      flex: 0.5,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <Box
            style={{
              textAlign: "center",
              cursor: "pointer",
              display: params.row.virtualteamowners.find(
                (owner) => owner.userid === Constants.loggedInUser.id
              )
                ? "block"
                : "none",
            }}
            onClick={() => {
              this.setState({
                showAddVirtualTeamModal: true,
                editOperation: true,
                sourceData: params.row,
              });
            }}
          >
            {" "}
            <BorderColorIcon color="primary" />
          </Box>
        );
      },
    },
  ];

  hideAddVirtualTeamModal = () => {
    this.setState({
      showAddVirtualTeamModal: false,
    });
  };

  handleValidation = (virtualTeamData) => {
    //TODO do validation if needed here
    return true;
  };

  addVirtualTeam = (virtualTeamData) => {
    this.setState({ loadingButton: true });
    if (this.state.editOperation) {
      //Updating VirtualTeam, and once virtualTeam is updated on call refresh the list of current virtualTeam
      VirtualTeamProxy.UpdateVirtualTeam(virtualTeamData, (response) => {
        if (response) {
          this.fetchVirtualTeamData(true);
          this.setState({ loadingButton: false });
          //Hidding virtualTeam modal
          this.hideAddVirtualTeamModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    } else {
      //Creating new VirtualTeam, and once virtualTeam is created on call refresh the list of current virtualTeam
      VirtualTeamProxy.AddVirtualTeam(virtualTeamData, (response) => {
        if (response) {
          this.fetchVirtualTeamData(true);
          this.setState({ loadingButton: false });
          //Hidding virtualTeam modal
          this.hideAddVirtualTeamModal();
        } else {
          this.setState({ errorSnackbar: true });
          this.setState({ loadingButton: false });
        }
      });
    }
  };

  editUser = (userData) => {
    this.setState({ loadingButton: true });
    UserProxy.UpdateUser(userData, (responseData) => {
      if (!responseData) {
        this.setState({ errorSnackbar: true });
        this.setState({ loadingButton: false });
      } else {
        this.setState({ loadingButton: false });
        this.hideAddUserModal();
      }
    });
  };

  hideAddUserModal = () => {
    this.setState({ showAddUserModal: false });
  };

  render() {
    const CustomToolbar = () => {
      return (
        <GridToolbarContainer
          sx={{
            display: "flex",
            alignItems: "center",
            marginHorizontal: "5px",
            "&.MuiDataGrid-toolbarContainer": {
              padding: "0px 4px !important",
            },
          }}
        >
          <GridToolbarColumnsButton />
          <GridToolbarFilterButton />
          <GridToolbarExport />
          <Box sx={{ flexGrow: 1, display: { sm: "none", md: "block" } }} />
          {this.state.showVirtualTeamLoadSpinner ? (
            <CircularProgress size="1rem" />
          ) : (
            <Tooltip title="Reload List">
              <RefreshOutlinedIcon
                color="primary"
                fontSize="medium"
                onClick={() => this.fetchVirtualTeamData(true)}
                sx={{ cursor: "pointer" }}
              />
            </Tooltip>
          )}

          {Utility.isAddAllowed(this.state.local_Permission) ? (
            <Tooltip title="Add Virtual Team">
              <Button
                color="info"
                variant="outlined"
                size="small"
                sx={{ ml: "5px" }}
                onClick={() =>
                  this.setState({
                    showAddVirtualTeamModal: true,
                    editOperation: false,
                    sourceData: {},
                  })
                }
                startIcon={<AddBoxOutlinedIcon size="large" />}
              >
                Virtual Team
              </Button>
            </Tooltip>
          ) : null}

          <GridToolbarQuickFilter debounceMs={500} />
        </GridToolbarContainer>
      );
    }
    let allowed = Utility.isReadAllowed(this.state.local_Permission)
    if (!allowed) {
      return <NoPermission />
    }
    const rows = this.state.virtualTeam;
    const columns = this.state.columnNames;
    // const columns = Utility.isUpdateAllowed(this.state.local_Permission) ? this.columns : this.columns.filter((col) => col.field !== 'edit')
    return (
      <Box>
        <CommonSnackbar
          show={this.state.errorSnackbar}
          message={<Box>{Constants.APiFailErrorMessage}</Box>}
          variant={"error"}
          autoHide={Constants.SnackBarCloseTimer}
          handleClose={() => this.setState({ errorSnackbar: false })}
          title="Failed"
        />
        <br />
        {this.state.showAddVirtualTeamModal ? (
          <AddVirtualTeamModal
            Show={true}
            handleClose={this.hideAddVirtualTeamModal}
            handleSave={this.addVirtualTeam}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            loading={this.state.loadingButton}
          />
        ) : (
          <Box />
        )}
        {this.state.showAddUserModal ? (
          <AddUserModal
            Show={true}
            handleClose={this.hideAddUserModal}
            handleSave={this.editUser}
            handleValidation={this.handleValidation}
            editOperation={this.state.editOperation}
            sourceData={this.state.sourceData}
            userId={this.state.userId}
            loading={this.state.loadingButton}
            saveButton={true}
          />
        ) : (
          <Box />
        )}
        <Box>
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "85vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "4px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "12px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "18px",
                },

                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.id}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns id, the other columns will remain visible
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
                sorting: {
                  sortModel: [{ field: "id", sort: "desc" }],
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              loading={this.state.showVirtualTeamLoadSpinner}
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    );
  }
}

export default VirtualTeamMaster;
